export const IS_V2 = false;
